export default {
    listagem: {
        titulo_pagina: 'Lista de Fabricantes',
        novo: 'Agregar Nuevo fabricante',
        table: {
            empty: 'No se encontró ningún fabricante',
            nome: 'Nombre',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Fabricante',
            editar: 'Editar Fabricante'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre del Fabricante'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo del fabricante'
            },
            botao_salvar : 'Guardar Fabricante'
        },
        create: {
            success: '¡Fabricante creado con éxito!',
            error: '¡Error al crear el fabricante!'
        },
        update: {
            success: '¡El fabricante editó con éxito!',
            error: '¡Error al editar el fabricante!'
        }
    }
}
